import React, { useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getRolesAssign } from "../redux/actionCreator";
import { rolesAssign_lists, rolesAssign_path } from "../redux/commonReducer";
import { API_BASE_IMAGE_URL } from "../constants/configuration";
import AssignmentTab from "../components/AssignmentTab";
import { useLocation } from "react-router";
import Head from "../constants/Head";
import { useNavigate, useParams } from "react-router-dom";

function Assignments() {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { page } = useParams();

  const [language, setLanguage] = useState("");
  const [imageChange, setImageChange] = useState("");
  const [tabActive, setTabActive] = useState(0);

  // DATAS
  const rolesAssign = useSelector(rolesAssign_lists);
  const rolesAssignPath = useSelector(rolesAssign_path);

  useEffect(() => {
    dispatch(getRolesAssign());
  }, []);

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    setLanguage(lang);
    if (rolesAssign) {
      navigate(
        `/${localStorage.getItem("lang") == "en" ? "en" : "ar"}/assignments/${localStorage.getItem("lang") == "en"
          ? rolesAssign[location.state?.name || tabActive]?.title_slug_en
          : rolesAssign[location.state?.name || tabActive]?.title_slug_ar
        }`
      );
    }
  }, [localStorage.getItem("lang"), location.state]);

  useEffect(() => {
    if (rolesAssign?.length) {
      //   setImageChange(rolesAssign[0]?.banner_name);
      if (page) {
        let tab = rolesAssign?.find(
          (ele) => ele.title_slug_en == page || ele.title_slug_ar == page
        );
        let index = rolesAssign.findIndex(
          (ele) => ele.title_slug_en == page || ele.title_slug_ar == page
        );
        if (tab == undefined) {
          navigate("/*")
        } else {
          setTabActive(index);
          setImageChange(tab?.banner_name);
        }
      } else {
        setImageChange(rolesAssign[0]?.banner_name);
        navigate(
          `/${localStorage.getItem("lang") == "en" ? "en" : "ar"}/assignments/${localStorage.getItem("lang") == "en"
            ? rolesAssign[0]?.title_slug_en
            : rolesAssign[0]?.title_slug_ar
          }`
        );
      }
    }
  }, [rolesAssign, location]);

  const handleTabSelect = (key) => {
    setTabActive(key);
    setImageChange(rolesAssign[key]?.banner_name);
    navigate(
      `/${localStorage.getItem("lang") == "en" ? "en" : "ar"}/assignments/${localStorage.getItem("lang") == "en"
        ? rolesAssign[key]?.title_slug_en
        : rolesAssign[key]?.title_slug_ar
      }`
    );
  };

  return (
    <>
      <Head
        title={t("html_title.assignments")}
        metatitle={t("html_title.assignments")}
        metaDescription={t("html_title.assignments")}
      />
      <Header />
      <section className="innerpage__header">
        <div className="container sm-pad-0">
          <div className="banner__image" style={{ minHeight: 330 }}>
            <img
              src={API_BASE_IMAGE_URL + rolesAssignPath + "/" + imageChange}
              className="w-100"
              alt=""
            />
            <div className="contents">
              <div className="row">
                <div className="col-md-12 p-0">
                  <div className="header__title bottomPad">
                    <h2>{t("roles_assignments")}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="roles__assignments bg-default">
        <div className="container">
          <Tab.Container
            id="left-tabs-example"
            activeKey={tabActive}
            onSelect={handleTabSelect}
          >
            <Nav variant="pills" className="flex-column">
              <div className="assignment__tabItems">
                <Row className="nav-scroll">
                  {rolesAssign?.map((ele, i) => {
                    return (
                      <Col md={2} sm={44} key={i} className="col-tab-3">
                        <Nav.Item>
                          <Nav.Link eventKey={`${i}`}>
                            <div className="assignment__tab">
                              <div className="icon">
                                <img
                                  src={
                                    API_BASE_IMAGE_URL +
                                    rolesAssignPath + "/" +
                                    ele?.body_icon_name
                                  }
                                  alt=""
                                />
                              </div>
                              <div className="title">
                                <h5>
                                  {language == "en"
                                    ? ele?.sub_title_en
                                    : ele?.sub_title_ar}
                                </h5>
                                <h3>
                                  {language == "en"
                                    ? ele?.title_en
                                    : ele?.title_ar}
                                </h3>
                              </div>
                            </div>
                          </Nav.Link>
                        </Nav.Item>
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </Nav>

            <Tab.Content>
              {rolesAssign?.map((ele, i) => {
                return (
                  <Tab.Pane eventKey={`${i}`} key={i}>
                    <AssignmentTab data={ele} />
                  </Tab.Pane>
                );
              })}
            </Tab.Content>
          </Tab.Container>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Assignments;
